import { render } from "./Subtitle.vue?vue&type=template&id=2a9fdd05&ts=true&lang=pug"
import script from "./Subtitle.vue?vue&type=script&lang=ts"
export * from "./Subtitle.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__